<ng-container *ngIf="!(updatingFarmaciasEnlace$ | async); else loadingBlock">
    <ng-container *ngIf="(farmaciasEnlace$ | async) as farmacias">
        <div fxLayout="row" class="full-width" fxLayoutAlign="center start">
            <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="12px" fxFlex.gt-md="30" fxFlex="80">
                <mat-card *ngFor="let farmacia of farmacias" class="full-width">
                    <mat-card-content>
                        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px">
                            <div fxLayout="column" fxLayoutGap="5px">
                                <span class="mat-h4 no-margin">{{ farmacia.nbFarmacia }}</span>
                                <span class="mat-body no-margin">{{ farmacia.direccion.length > 70 ?
                                    farmacia.direccion.substring(0,67) + '...' : farmacia.direccion }}</span>
                            </div>
                            <div fxLayout.gt-xs="row" fxLayout="column"
                                fxLayoutAlign.gt-xs="end start" fxLayoutAlign="start start" fxLayoutGap="5px">
                                <button mat-raised-button *ngFor="let enlace of farmacia.enlaces"
                                    (click)="onClick(farmacia, enlace)" [color]="enlace.icono">
                                    <mat-icon [svgIcon]="enlace.icono"></mat-icon>
                                </button>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
                <button mat-flat-button class="full-width" (click)="goBack()">
                    Regresar
                </button>
            </div>
        </div>
    </ng-container>
</ng-container>
<ng-template #loadingBlock>
    <div fxLayout="column" fxLayoutAlign="center center">
        <mat-progress-spinner color="primary" diameter="50" mode="indeterminate">
        </mat-progress-spinner>
    </div>
</ng-template>